import { comics } from '@/mocks/comics';
import ComicCard from '@/components/feature/ComicCard';

export default function LatestUpdates() {
  const latest = [...comics].sort(
    (a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime()
  ).slice(0, 8);

  return (
    <section className="max-w-[1400px] mx-auto px-4 md:px-6 py-12 md:py-16">
      <div className="mb-8">
        <h2 className="text-xl md:text-2xl font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
          最近更新
        </h2>
        <p className="text-sm text-foreground-500 mt-1.5">实时追踪最新漫画更新动态</p>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
        {latest.map((comic) => (
          <div key={comic.id} className="relative">
            <ComicCard comic={comic} />
            {comic.chapters.length > 0 && (
              <div className="mt-2 px-0.5">
                <span className="text-xs text-accent-500 font-medium">
                  更新至 {comic.chapters[0].title}
                </span>
              </div>
            )}
          </div>
        ))}
      </div>
    </section>
  );
}